module.exports = __webpack_public_path__ + "img/The-Baldwin-Group-club.390510d4.jpg";